<div class="prs-auth-modal-panel" data-testing-id="sales-rep-account-select-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-auth-modal-sales-account-title">
      {{ titleKey | translate }}
    </h2>
    <button
      *ngIf="dismissible"
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <p class="text-muted mb-3">{{ hintKey | translate }}</p>

    <label class="form-label" for="prs-sales-rep-account">{{
      'login.sales_rep.account_label' | translate
    }}</label>
    <select
      id="prs-sales-rep-account"
      class="form-select"
      name="salesRepAccount"
      [(ngModel)]="selectedCustomerNo"
      data-testing-id="sales-rep-account-select"
    >
      <option value="" disabled>{{ 'login.sales_rep.account_placeholder' | translate }}</option>
      @for (account of accounts; track account.customerNo) {
      <option [value]="account.customerNo">{{ account.companyName }} ({{ account.customerNo }})</option>
      }
    </select>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="dismissible"
      type="button"
      class="btn btn-secondary"
      data-testing-id="sales-rep-account-cancel"
      (click)="hide()"
    >
      {{ 'sales_rep.accounts.cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!selectedCustomerNo"
      data-testing-id="sales-rep-account-continue"
      (click)="confirm()"
    >
      {{ continueKey | translate }}
    </button>
  </div>
</div>
